<template>
    <van-dialog ref="dialogRef" :show="props.show" :title="props.title" show-cancel-button @confirm="handleConfirm" @cancel="handleCancel">
        <img src="@/assets/img/icon32.png" class="closeicon" @click="handleCancel">
        <slot></slot>
    </van-dialog>
</template>
<script setup>
import {ref, defineProps, defineEmits} from "vue";
const props = defineProps({
    title: {
        type: String,
        default: "标题"
    },
    show: {
        type: Boolean,
        default: false
    },
    fn: {
        type: Function,
        default: () => {}
    }
});

const dialogRef = ref();

// const show = ref(true);

const emit = defineEmits(['update:show'])
const handleCancel = async () => {
    // await nextTick();
    // dialogRef.value.visible = false;
    emit('update:show', false)
};

const handleConfirm = async () => {
    await props.fn();
    // emit('update:show', false)
};
</script>
<style scoped>
    .closeicon {
        width: 4.2667vw;
        height: 4.2667vw;
        position: absolute;
        top: 4.2667vw;
        right: 4.2667vw;
    }
    .van-dialog__header {
        padding-top: 0!important;
    }
</style>